import React, { useContext } from 'react';
import { getComponentName } from './helpers';

export const MobileContext = React.createContext<boolean>(false);
MobileContext.displayName = 'MobileContext';

export interface WithMobileContextProps {
  isMobile?: boolean;
}

// HOC for convenience...
export function withMobileContext<TProps>(
  Component: React.ComponentType<TProps & WithMobileContextProps>
) {
  const DecoratedComponent: React.FC<TProps> = props => {
    const isMobile = useContext(MobileContext);
    return <Component isMobile={isMobile} {...props} />;
  };
  DecoratedComponent.displayName = `withMobileContext(${getComponentName(
    Component
  )})`;
  return DecoratedComponent;
}
